/**
 * Returns the size of the file in Megabytes
 *
 * @param {File} file
 */
export function getSizeInMB(file) {
  return file.size / 1024 / 1024;
}
